import { render, staticRenderFns } from "./UserAssignmentHistoryAI.vue?vue&type=template&id=bd7ec014&scoped=true&"
import script from "./UserAssignmentHistoryAI.vue?vue&type=script&lang=js&"
export * from "./UserAssignmentHistoryAI.vue?vue&type=script&lang=js&"
import style0 from "./UserAssignmentHistoryAI.vue?vue&type=style&index=0&id=bd7ec014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7ec014",
  null
  
)

export default component.exports